import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0617 = React.lazy(() => import('./symbols/0617_picture_image_photo'));
const Symbol0618 = React.lazy(() => import('./symbols/0618_album_picture_image_photo'));
const Symbol0619 = React.lazy(() => import('./symbols/0619_album_picture_image_photo'));
const Symbol0620 = React.lazy(() => import('./symbols/0620_picture_image_photo_desk'));
const Symbol0621 = React.lazy(() => import('./symbols/0621_polaroid_picture_image_photo'));
const Symbol0622 = React.lazy(() => import('./symbols/0622_wall_picture_image_photo'));
const Symbol0623 = React.lazy(
  () => import('./symbols/0623_not_available_broken_missing_picture_image_photo')
);
const Symbol0624 = React.lazy(() => import('./symbols/0624_photo_camera'));
const Symbol0625 = React.lazy(() => import('./symbols/0625_photo_camera'));
const Symbol0626 = React.lazy(() => import('./symbols/0626_photo_camera_upload_computer'));
const Symbol0627 = React.lazy(() => import('./symbols/0627_photo_camera_portrait'));
const Symbol0628 = React.lazy(() => import('./symbols/0628_photo_camera_landscape'));
const Symbol0629 = React.lazy(() => import('./symbols/0629_photo_camera_tripod_stand'));
const Symbol0630 = React.lazy(() => import('./symbols/0630_photo_wall_frame'));
const Symbol0631 = React.lazy(() => import('./symbols/0631_camera_setting_close_up_macro'));

export interface IProps {}

const Photography: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0617_picture_image_photo" symbol={<Symbol0617 />} />
      <LazySymbol id="0618_album_picture_image_photo" symbol={<Symbol0618 />} />
      <LazySymbol id="0619_album_picture_image_photo" symbol={<Symbol0619 />} />
      <LazySymbol id="0620_picture_image_photo_desk" symbol={<Symbol0620 />} />
      <LazySymbol id="0621_polaroid_picture_image_photo" symbol={<Symbol0621 />} />
      <LazySymbol id="0622_wall_picture_image_photo" symbol={<Symbol0622 />} />
      <LazySymbol
        id="0623_not_available_broken_missing_picture_image_photo"
        symbol={<Symbol0623 />}
      />
      <LazySymbol id="0624_photo_camera" symbol={<Symbol0624 />} />
      <LazySymbol id="0625_photo_camera" symbol={<Symbol0625 />} />
      <LazySymbol id="0626_photo_camera_upload_computer" symbol={<Symbol0626 />} />
      <LazySymbol id="0627_photo_camera_portrait" symbol={<Symbol0627 />} />
      <LazySymbol id="0628_photo_camera_landscape" symbol={<Symbol0628 />} />
      <LazySymbol id="0629_photo_camera_tripod_stand" symbol={<Symbol0629 />} />
      <LazySymbol id="0630_photo_wall_frame" symbol={<Symbol0630 />} />
      <LazySymbol id="0631_camera_setting_close_up_macro" symbol={<Symbol0631 />} />
    </>
  );
});

Photography.displayName = 'Photography';

export default Photography;
